import {toast} from "react-toastify";
import Auth from "../../http_request/Model/auth/Auth";

const GetProductList = (setUserList, setLoading) => {


    Auth.request({
        beforeSend: () => {
            setLoading(true)
        },
        success: (result) => {
            let res = []
            result.map((item) => {
               return  res = [...res, {label: item, value: item}]
            })
            setUserList(res)
        },
        error: ({error}) => {
            toast.error(error.data.message);
        },
        final: () => {
            setLoading(false)
        },
    }).addParams({page: 1, page_size: 100000}).UsersFullName()

}
export default GetProductList